import request from '../utils/request'

export function ErrosRequest() {
  return request({
    url: 'dashboard/erros_logs',
    method: 'get'
  })
}
